<div class="work-ui-address-autocomplete">
  <work-ui-input-field-with-options
    class="work-ui-address-autocomplete__input"
    [id]="id()"
    [name]="name()"
    type="text"
    iconName="search"
    [label]="label() | translate"
    [placeholder]="placeholder() | translate"
    [required]="required()"
    [disableHint]="true"
    [disabled]="disabled()"
    [loadingState]="loadingState()"
    [dynamicDropdownOptions]="true"
    [dropdownOptions]="dropdownOptions()"
    (valueChange)="onSearchChanged($event)"
    (dropDownOptionChange)="onOptionSelected($event)" />
  <span class="work-ui-address-autocomplete__hint">
    <work-ui-icon name="auto_awesome" [fontSize]="16" fontColor="primary" [paddingSize]="0" />
    <small>{{ 'ADRESSE_SUCHEN_HINT' | translate }}</small>
  </span>
</div>
